export default "__VITE_ASSET__CQbB8RV4__"